import { useEffect, useState, useRef } from "react";
import VendorMoving from "../../../CompanyAdmin/VendorResponse/VendorMoving";
import assignedTask from '../../../../Assets/assignedTask.png'
import comingCrane from '../../../../Assets/comingCrane.png'
import checksuccess from '../../../../Assets/checksuccess.png'
import ratingStar from '../../../../Assets/ratingStar.png'
import NoDataFound from "../../../../Component/Customers/Cards/NoDataFound";
import axios from "axios";
import crossUser from '../../../../Assets/crossUser.png'
import searchinterfacesymbol from '../../../../Assets/search-interface-symbol.png'
import filterUser from '../../../../Assets/filterUser.png'
import viewcase from '../../../../Assets/viewcase.png'
import Modal from "../../../../Component/CompanyAdmin/Location1/Modal";
import { useWebSocket } from "../../../../context/WebSocketContext";
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import ArticleIcon from '@mui/icons-material/Article';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import { Filter } from "lucide-react";
import icon11 from '../../../../Assets/crane/icon11.svg'
import frontLeft from '../../../../Assets/crane/front-left.jpg'


import {
    CheckCircle,
    XCircle,
    CalendarDays,
    Calendar,
    Clock,
    History,
} from "lucide-react";



function haversine(lat1, lon1, lat2, lon2) {
    console.log("accident latitude", lat1)
    console.log("accident longtitude", lon1)
    console.log("vehicle latitiude", lat2)
    console.log("vehicle longtitude", lon2)

    const toRad = (value) => (value * Math.PI) / 180;
    const R = 6371; // Earth radius in km

    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;
    return distance;
}

const Notification = ({ message, onClose }) => {
    return (
        <div className="notification">
            <button className="close-btn" onClick={onClose}>✖</button>
            <p>{message}</p>
        </div>
    );
};

const CraneAcceptedOrders = ({ data, recentlyCancelled }) => {
    const [totalAcceptedCases, setTotalAcceptedCase] = useState([]);
    console.log("data from crane order delete", recentlyCancelled)
    console.log("data", data)

    const [recentlyCancelledData, setRecentlyCancelledData] = useState(false)
    const [gotCancelled, setGotCancelled] = useState(false)

    const [spareUseData, setSpareUseData] = useState([]);
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    console.log('totalAcceptedCases', totalAcceptedCases)
    const { messages } = useWebSocket()
    console.log('spareUseData', spareUseData)


    const [openDetails, setOpenDetails] = useState(false);
    const [choosenCase, setChoosenCase] = useState([])

    const [vendorCurrentLatitude, setVendorCurrentLatitude] = useState("")
    const [vendorCurrentLongitude, setVendorCurrentLongitude] = useState("")
    const [distance, setDistances] = useState([])

    const [filter, setFilter] = useState('')
    const [openFilterModal, setOpenFilterModal] = useState(false)




    const [currentStage, setCurrentStage] = useState([]); // Example stage
    const [avg, setAvg] = useState([])

    const containerRef = useRef();

    const formatDateToDDMMYYYY = (dateString) => {
    if (!dateString) return "";
    // Handle ISO format (yyyy-mm-dd or yyyy-mm-ddT...)
    const date = new Date(dateString);
    // Check if date is valid
    if (isNaN(date.getTime())) return dateString;
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

    const formatTimeTo12Hour = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);

    // Check if date is valid
    if (isNaN(date.getTime())) return "";
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0"); 
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    return `${hours}:${minutes}:${seconds} ${ampm}`;
  };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setOpenDetails(false);
            }
        };

        if (openDetails) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [openDetails]);

    const stages = [
        { label: "Processing", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/comingCrane.png' },
        { label: "Admin Accepted", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/assignedTask.png' },
        { label: "Customer Accepted", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/checksuccess.png' },
    ];


    useEffect(() => {
        setTotalAcceptedCase(data)
        setSpareUseData(data)
        // setCurrentStage([])
        if (choosenCase.length > 0) {
            const updatedCase = data.find((item) => (
                console.log('data for choosen case', item.accidentFileNo, choosenCase[0].accidentFileNo),
                item.accidentFileNo === choosenCase[0].accidentFileNo
            ));
            console.log('updatedcase', updatedCase)
            if (updatedCase) {
                setChoosenCase([updatedCase]);
            } else {
                setChoosenCase([]);
                setOpenDetails(false)
            }
        }
        setRecentlyCancelledData(recentlyCancelled)
        if (recentlyCancelled !== "") setGotCancelled(true)
    }, [data])

    const handleChoosenCase = (item) => {
        setChoosenCase([])
        setChoosenCase([item])
        setOpenDetails(true)
    }

    const getStage = (customerAcceptedVendor, acceptedByAdmin) => {
        return customerAcceptedVendor ? 2 : acceptedByAdmin === 'accept' ? 1 : 0;
    }
    useEffect(() => {

        if (totalAcceptedCases.length) {
            const avg = new Array(totalAcceptedCases.length).fill(0);
            const currentStage = totalAcceptedCases.map((item) => {
                console.log("item.details[0]?.customerAcceptedVendor", item.details[0]?.customerAcceptedVendor)
                return getStage(item.details[0]?.customerAcceptedVendor, item.details[0]?.acceptedByAdmin)
            })
            totalAcceptedCases.forEach((item, index) => {
                // getVendorLocation(item.crane, item.accidentLatitude, item.accidentLongitude, index);
                // getCustomerRating(item.CustomerCode)
            });
        }
    }, [totalAcceptedCases]);



    const getFilteredData = (filter) => {
        console.log("data is here");
        const filteredData = [];

        const now = new Date();  // Current date and time
        const oneDay = 24 * 60 * 60 * 1000; // One day in milliseconds
        const yesterday = new Date(now.getTime() - oneDay); // Yesterday's date and time
        const weekBefore = new Date(now.getTime() - (oneDay * 7));
        const monthBefore = new Date(now.getTime() - (oneDay * 30));

        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        const todayDate = formatDate(now);
        const yesterdayDate = formatDate(yesterday);
        const weekBeforeDate = formatDate(weekBefore);
        const monthBeforeDate = formatDate(monthBefore);

        console.log("todayDate", todayDate);
        console.log("yesterdayDate", yesterdayDate);

        for (let i = 0; i < spareUseData.length; i++) {
            let getTime = spareUseData[i].details[0].filedCaseFullyTime.split('|');
            let assignedDate = getTime[0];
            let assignedTime = getTime[1];
            let assignedDateTime = new Date(`${assignedDate} ${assignedTime}`);

            if (filter === 'daily') {
                console.log("here I am daily");
                if (assignedDate === todayDate || assignedDate === yesterdayDate) {
                    const timeDifference = now - assignedDateTime;
                    if (timeDifference <= oneDay) {
                        console.log("Match found within last 24 hours:", spareUseData[i]);
                        filteredData.push(spareUseData[i]);
                    }
                }
            } else if (filter === 'weekly') {
                console.log("here I am weekly");
                if (assignedDateTime >= weekBefore && assignedDateTime <= now) {
                    console.log("Match found within last 7 days:", spareUseData[i]);
                    filteredData.push(spareUseData[i]);
                }
            } else if (filter === 'monthly') {
                if (assignedDateTime >= monthBefore && assignedDateTime <= now) {
                    console.log("Match found within last 30 days:", spareUseData[i]);
                    filteredData.push(spareUseData[i]);
                }
            }
            else if (filter === 'year') {
                const yearBefore = new Date(now.getTime() - (oneDay * 365)); // Calculate date one year ago
                if (assignedDateTime >= yearBefore && assignedDateTime <= now) {
                    console.log("Match found within last year:", spareUseData[i]);
                    filteredData.push(spareUseData[i]);
                }
            }
        }

        if (filter === 'newest') {
            console.log("Sorting by newest to oldest");
            spareUseData.sort((a, b) => {
                const dateA = new Date(a.details[0].filedCaseFullyTime.split('|').join(' '));
                const dateB = new Date(b.details[0].filedCaseFullyTime.split('|').join(' '));
                return dateB - dateA; // Descending order
            });
            setTotalAcceptedCase([...spareUseData]);
        } else if (filter === 'oldest') {
            console.log("Sorting by oldest to newest");
            spareUseData.sort((a, b) => {
                const dateA = new Date(a.details[0].filedCaseFullyTime.split('|').join(' '));
                const dateB = new Date(b.details[0].filedCaseFullyTime.split('|').join(' '));
                return dateA - dateB; // Ascending order
            });
            setTotalAcceptedCase([...spareUseData]);
        } else {
            setTotalAcceptedCase(filteredData);
        }
    };


    const settingFilter = (filter) => {
        console.log("filter", filter)
        setFilter(filter)
        getFilteredData(filter)
        setOpenFilterModal(false)
    }

    const getVendorLocation = async (crane, accidentLatitude, accidentLongitude, index) => {
        try {
            console.log("disntaceadfafdaf", distance)
            console.log("craninging", crane, accidentLatitude, accidentLongitude, index)

            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getVendorCurrentLocation/${crane}`, { headers: { Authorization: `Bearer ${token}` } });
            if (response.data.status === true) {
                let vendorCurrentLatitude = response.data.data[0].latitude;
                let vendorCurrentLongitude = response.data.data[0].longitude;
                setVendorCurrentLatitude(vendorCurrentLatitude)
                setVendorCurrentLongitude(vendorCurrentLongitude)
                const calculatedDistance = haversine(accidentLatitude, accidentLongitude, vendorCurrentLatitude, vendorCurrentLongitude).toFixed(2);
                distance.push(calculatedDistance)
            }
            else if (response.data.message === "User Not found take Location") {
                console.log("User Not found take Location")
            }
        } catch (error) {
            console.log("error in get Vendor Location", error.message)
        }
    }

    const getCustomerRating = async (customerCode) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/vendorRatingToCustomer/${customerCode}/${userId}`, { headers: { Authorization: `Bearer ${token}` } });
            console.log("coming Customer Rating", response.data)
            if (response.data.status === 404) {
                console.log("Not Found")
                avg.push(0)
            }
            else if (response.data.status === true) {
                avg.push(response.data.data);
            }
        } catch (error) {
            console.log("Error from get Vendor Rating", error.message)
        }
    }


    const [showFilter, setShowFilter] = useState(false);

    const toggleFilter = () => {
        setShowFilter((prev) => !prev);
    };
    const [searchValue, setSearchValue] = useState('');

    const handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchValue(value);
        const newRows = spareUseData.filter((row) => {
            const formattedId = String(row.id).padStart(4, '0').toLowerCase(); // Make sure the formatted ID is lowercase
            const searchLower = value; // Use the updated search value directly
            const idValue = formattedId.includes(searchLower);
            const vehicleNoValue = (row.reg ?? '').toLowerCase().includes(searchLower);
            return vehicleNoValue;
        });

        setTotalAcceptedCase(newRows);
    };
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {

        const filteredData = data
            .filter(item =>
                item?.reg
                    ?.toLowerCase()
                    .includes(searchTerm.toLowerCase())
            )
            .sort((a, b) => {
                const timeA = Date.parse(a.details?.[0]?.connectedVendorFullyTime || "");
                const timeB = Date.parse(b.details?.[0]?.connectedVendorFullyTime || "");

                if (isNaN(timeA) && isNaN(timeB)) return 0;
                if (isNaN(timeA)) return 1;
                if (isNaN(timeB)) return -1;

                return timeB - timeA; // descending
            });

        if (filteredData && filteredData.length > 0) {
            setTotalAcceptedCase(filteredData);
        }

        setSpareUseData(data)
        // setCurrentStage([])
        if (choosenCase.length > 0) {
            const updatedCase = data.find((item) => (
                console.log('data for choosen case', item.accidentFileNo, choosenCase[0].accidentFileNo),
                item.accidentFileNo === choosenCase[0].accidentFileNo
            ));
            console.log('updatedcase', updatedCase)
            if (updatedCase) {
                setChoosenCase([updatedCase]);
            } else {
                setChoosenCase([]);
                setOpenDetails(false)
            }
        }
        setRecentlyCancelledData(recentlyCancelled)
        if (recentlyCancelled !== "") setGotCancelled(true)

    }, [data, searchTerm])


    return (
        <div className="font-satoshi h-[100vh] bg-white">
            <div style={{
                marginBottom: "100px", marginTop: "-1rem"
            }}>
                <div className="container   mb-5" style={{
                    maxWidth: "500px",
                    height: "30px",
                    marginBottom: "30px",
                    paddingTop: "0px"

                }}>
                    <div className="relative">
                        <div className="flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid h-[40px] box-border m-3" style={{ marginTop: "10px" }}>
                            <input
                                type="text"
                                className="font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151] h-[24px] leading-[24px] p-0 m-0"
                                placeholder="Search.."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                        {showFilter && (
                            <div style={{ boxShadow: '2px 2px 2px' }} className="absolute top-full right-4 transform -translate-y-10 bg-white shadow-xl border rounded-xl w-60 z-50">
                                <ul className="p-2 text-sm">
                                    <li
                                        onClick={() => settingFilter('newest')}
                                        className="hover:bg-gray-100 px-3 py-2 rounded cursor-pointer flex items-center gap-2"
                                    >
                                        <CheckCircle className="w-4 h-4 text-green-500" />
                                        Newest - Oldest
                                    </li>
                                    <li
                                        onClick={() => settingFilter('oldest')}
                                        className="hover:bg-gray-100 px-3 py-2 rounded cursor-pointer flex items-center gap-2"
                                    >
                                        <XCircle className="w-4 h-4 text-red-500" />
                                        Oldest - Newest
                                    </li>
                                    <li
                                        onClick={() => settingFilter('daily')}
                                        className="hover:bg-gray-100 px-3 py-2 rounded cursor-pointer flex items-center gap-2"
                                    >
                                        <CalendarDays className="w-4 h-4 text-blue-500" />
                                        Yesterday
                                    </li>
                                    <li
                                        onClick={() => settingFilter('weekly')}
                                        className="hover:bg-gray-100 px-3 py-2 rounded cursor-pointer flex items-center gap-2"
                                    >
                                        <History className="w-4 h-4 text-indigo-500" />
                                        Last 7 Days
                                    </li>
                                    <li
                                        onClick={() => settingFilter('montly')}
                                        className="hover:bg-gray-100 px-3 py-2 rounded cursor-pointer flex items-center gap-2"
                                    >
                                        <Calendar className="w-4 h-4 text-purple-500" />
                                        Last 30 Days
                                    </li>
                                    <li
                                        onClick={() => settingFilter('year')}
                                        className="hover:bg-gray-100 px-3 py-2 rounded cursor-pointer flex items-center gap-2"
                                    >
                                        <Clock className="w-4 h-4 text-gray-700" />
                                        Year and Before
                                    </li>
                                </ul>
                            </div>
                        )}
                    </div>
                </div>
                <div>

                    {gotCancelled && (
                        <div>
                            <Notification
                                message={recentlyCancelledData}
                                onClose={() => setGotCancelled(false)}
                            />
                        </div>
                    )}
                </div>
                {totalAcceptedCases.length > 0 && (
                    <div className="grid md:grid-cols-2 grid-cols-1">
                        {totalAcceptedCases.map((item, dataIndex) => (
                            <div onClick={() => handleChoosenCase(item)} style={{ backgroundColor: 'linear-gradient(47deg,#649bba, transparent)', border: '1px solid ', boxShadow: '3px 2px 0px 0px' }} className=" border-[1px] border-[#E7E4FC] pb-[1rem] rounded-[12px] m-3 mt-2 ">
                                <div className=" p-1" style={{ borderRadius: '10px', opacity: '0.9' }}>
                                    <div className="flex items-center justify-around">
                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/front-left.jpg' className="h-[3rem] w-[4rem] mt-[1rem] mr-[1rem]" alt="vehicle" />
                                        <div className="flex grid-cols-2 text-[11px] sm:grid gap-x-[2rem] gap-y-[1rem] mt-[1rem] p-2">
                                            {[
                                                {
                                                    title: item.reg,
                                                    subtitle: "Vehicle No",
                                                },
                                                {
                                                    title: (
                                                    <div className="flex flex-col">
                                                    <span>
                                                        {formatDateToDDMMYYYY(
                                                        item.details[0].connectedVendorFullyTime
                                                        )}
                                                    </span>
                                                    <span className="text-xs text-gray-600">
                                                        {formatTimeTo12Hour(
                                                            item.details[0].connectedVendorFullyTime
                                                             )}
                                                    </span>
                                                    </div>
                                                    ),
                                                    subtitle: "Registered at",
                                                }

                                            ].map((block, idx) => (
                                                <div key={idx} className="flex flex-col mt-[1rem] mb-2">
                                                    <h6 className="m-0 font-[700] font-satoshi text-sm text-sm md:text-2xl text-[#0A0119] pb-[6px] leading-tight truncate">
                                                        {block.title}
                                                    </h6>
                                                    <p className={`font-[500] m-0 font-satoshi text-xs text-[#515151] leading-snug ${idx === 0 ?'mt-3' : ''}`}>
                                                        {block.subtitle}
                                                    </p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>


                                </div>
                                {/* <div className="flex justify-end">
  <button
    onClick={() => handleChoosenCase(item)}
    className="bg-[#21A6E9] px-6 py-1 rounded-full text-white font-satoshi font-[400] text-sm"
  >
    View
  </button>
</div> */}

                            </div>
                        ))}
                    </div>
                )}

                {openDetails && (
                    <div style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "transparent", // semi-transparent background
                        zIndex: 1001,
                        display: "flex",
                        // alignItems: "flex-end", // positions the container at the bottom
                        justifyContent: "center",
                        animation: "slideUp 0.5s ease-out",
                    }}>
                        <div ref={containerRef} style={{ position: "static", boxShadow: "none", borderRadius: "10px 10px 0px 0px" }}>
                            <VendorMoving item={choosenCase[0]} />
                        </div>
                    </div>
                )}


                {totalAcceptedCases.length === 0 && (
                    <NoDataFound />
                )}

                <Modal isOpen={openFilterModal} onClose={() => setOpenFilterModal(!openFilterModal)}>
                    {openFilterModal && (
                        <div style={{ textAlign: "center", marginTop: "30px", flexDirection: "column", display: 'flex', alignItems: 'center', justifyContent: "center" }}>
                            <p style={{ color: "#000000", fontWeight: "bold", marginBottom: "10px", fontSize: "15px", border: "1px solid red", background: "rgb(0 243 122 / 65%)", minWidth: "200px", borderRadius: "20px", padding: "7px" }} onClick={() => { settingFilter('newest') }}>newest to oldest</p>
                            <p style={{ color: "#000000", fontWeight: "bold", marginBottom: "10px", fontSize: "15px", border: "1px solid red", background: "rgb(0 243 122 / 65%)", minWidth: "200px", borderRadius: "20px", padding: "7px" }} onClick={() => { settingFilter('oldest') }}>oldest to newest</p>
                            <p style={{ color: "#000000", fontWeight: "bold", marginBottom: "10px", fontSize: "15px", border: "1px solid red", background: "rgb(0 243 122 / 65%)", minWidth: "200px", borderRadius: "20px", padding: "7px" }} onClick={() => { settingFilter('daily') }}>Yesterday</p>
                            <p style={{ color: "#000000", fontWeight: "bold", marginBottom: "10px", fontSize: "15px", border: "1px solid red", background: "rgb(0 243 122 / 65%)", minWidth: "200px", borderRadius: "20px", padding: "7px" }} onClick={() => { settingFilter('weekly') }}>Last 7 days</p>
                            <p style={{ color: "#000000", fontWeight: "bold", marginBottom: "10px", fontSize: "15px", border: "1px solid red", background: "rgb(0 243 122 / 65%)", minWidth: "200px", borderRadius: "20px", padding: "7px" }} onClick={() => { settingFilter('monthly') }}>Last 30 days</p>
                            <p style={{ color: "#000000", fontWeight: "bold", marginBottom: "10px", fontSize: "15px", border: "1px solid red", background: "rgb(0 243 122 / 65%)", minWidth: "200px", borderRadius: "20px", padding: "7px" }} onClick={() => { settingFilter('year') }}>Year</p>
                        </div>
                    )}
                </Modal>
            </div>
            <div
            >

                {/* <div>
                    <BottomNavigationVendor />
                </div> */}

            </div>
        </div>
    )
}

export default CraneAcceptedOrders;








